import React, { useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Button, ButtonGroup, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";

import { Common, DeleteTeacherById, RolesEnum } from "../../../helper";
import * as commonApi from "../../../api/commonApi";
import { AssignClass, AssignRole, EditUser } from "./";
import { hasAny, isEmptyObject } from "../../../util";
import { success } from "../../Shared";

import "../../../assets/stlyes/Modals.css";

const Action = (props) => {
  const { userId, foreName, surName, getData, show } = props;
  const [assignClass, setAssignClass] = useState(false);
  const [assignRole, setAssignRole] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [isUserId, setIsUserId] = useState("");
  const MySwal = withReactContent(Swal);
  let userData = useSelector((state) => state.login.user);
  const isAdmin = hasAny(userData.userType, [RolesEnum.Admin])
  // const roles = {values : [ {name : Roles.Admin, id: RolesEnum.Admin},{name : Roles.LeadTeacher, id: RolesEnum.LeadTeacher},{name : Roles.Teacher, id: RolesEnum.Teacher}]}

  const deleteTeacher = () => {
    MySwal.fire({
      title: Common.Delete,
      text: DeleteTeacherById(foreName, surName),
      type: "success",
      showCancelButton: true,
      confirmButtonText: Common.DisableUser,
    }).then((result) => {
      if (result.value) {
        confirmDeleteTeacher();
      } else {
        MySwal.fire(Common.NotDeleted);
      }
    });
  };

  const confirmDeleteTeacher = async () => {
    const deleteTeacher = await commonApi.updateUserActiveStatus({
      id: userId,
      active: false
    });
    if (!isEmptyObject(deleteTeacher)) {
      success(`${deleteTeacher.Items.firstName} ${deleteTeacher.Items.lastName} is Disabled`);
      getData();
    }
  };

  return (
    <>
      <DropdownButton as={ButtonGroup} id="dropdown-variants-Secondary" title={"Action"} >
        <Button onClick={() => { setIsUserId(userId); setAssignClass(true); }} className="modal-button d-flex justify-content-start" >
          <AddOutlinedIcon />&nbsp;{Common.AssignClass}
        </Button>
        {isAdmin && show !== 7 && <Button
          onClick={() => {
            setIsUserId(userId);
            setAssignRole(true);
          }}
          className="modal-button d-flex justify-content-start"
        >
          <AddOutlinedIcon />&nbsp;{Common.AssignRole}
        </Button>}
        {false && <Button onClick={() => { setIsUserId(userId); setEditUser(true) }} className="modal-button d-flex justify-content-start" >
          <EditOutlinedIcon />&nbsp;{Common.EditUser}
        </Button>}

        <Dropdown.Divider />
        {isAdmin && <Button onClick={deleteTeacher} className="modal-button-danger d-flex justify-content-start">
          <PersonOffOutlinedIcon />&nbsp;{Common.DisableUser}
        </Button>}
      </DropdownButton>

      {/* Modal For AssignClass */}
      <Modal
        show={assignClass}
        onHide={() => {
          setAssignClass(false);
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{Common.AssignClass}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AssignClass
            isUserId={isUserId}
            setAssignClass={setAssignClass}
            getData={getData}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* Modal For AssignRole */}
      <Modal
        show={assignRole}
        onHide={() => {
          setAssignRole(false);
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{Common.AssignRole}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AssignRole
            isUserId={isUserId}
            setAssignRole={setAssignRole}
            getData={getData}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal show={editUser} onHide={() => setEditUser(false)} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{Common.EditUser}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditUser isUserId={isUserId} getData={getData} />
          <hr />
          <AssignClass
            isUserId={isUserId}
            setAssignClass={setAssignClass}
            getData={getData}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export { Action };
